var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDartBoard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.306,
    height: 71.301,
    viewBox: "0 0 79.306 71.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122545",
    "data-name": "Group 122545",
    transform: "translate(921 -22023.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171706",
    "data-name": "Path 171706",
    d: "M61.664,43.508l7.888,6.638c-2.865,15.137-19.639,26.928-36.267,25.8C15.365,74.72-.09,58.963,0,40.038.089,21.364,14.988,6.08,33.925,4.787c16.7-1.14,33.535,11.482,35.686,25.971l-8.984,7.158c-5.038-17.233-15.87-25.921-34.321-19.805-9.854,3.266-15.556,13.637-14.82,24.238C12.17,52.2,20.225,61.705,30.126,64c7.176,1.665,14.489.94,19.734-4.195,4.753-4.656,7.977-10.873,11.8-16.3",
    transform: "translate(-921 22019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171709",
    "data-name": "Path 171709",
    d: "M54.626,37.623c-3.791.737-6.957,1.334-9.406-3.332-2.532-4.825-8.652-6.406-13.494-4.687a11.349,11.349,0,0,0-7.309,11.341,11.157,11.157,0,0,0,8.066,10.24c5.237,1.472,10.686-.33,13.191-5.393,2.266-4.581,5.53-2.946,8.805-2.822-.143,9.35-8.513,16.75-18.72,16.778A19.368,19.368,0,0,1,15.988,40.367c-.125-10.485,8.4-19.175,19.222-19.6,9.977-.391,18.9,7.243,19.416,16.854",
    transform: "translate(-921 22019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171711",
    "data-name": "Path 171711",
    d: "M41.783,37.737a32.81,32.81,0,0,0-5.805.411c-1.047.265-1.872,1.4-2.8,2.149.9.778,1.7,1.966,2.738,2.241a26.328,26.328,0,0,0,5.266.379q.26.837.518,1.675c-2.47.739-5.274,2.555-7.317,1.92-2.143-.666-4.912-3.669-4.932-5.676-.024-2.35,2.1-5.639,4.243-6.865,2.808-1.609,6.094-.522,8.086,3.766",
    transform: "translate(-921 22019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171712",
    "data-name": "Path 171712",
    d: "M79.306,36.655v7.086c-3.159,0-6.449.357-9.593-.163-1.413-.233-2.535-2.222-3.789-3.414,1.329-1.17,2.527-3.092,4.015-3.351,3.028-.528,6.212-.158,9.367-.158",
    transform: "translate(-921 22019)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDartBoard);
export default __webpack_public_path__ + "static/media/dartBoard.237af4ae884a6683a4940bbf81aa1b53.svg";
export { ForwardRef as ReactComponent };